"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.detectIOS = void 0;
const detectIOS = () => {
    var _a;
    return ([
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod',
    ].includes(navigator === null || navigator === void 0 ? void 0 : navigator.platform) ||
        (((_a = navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) === null || _a === void 0 ? void 0 : _a.includes('Mac')) && 'ontouchend' in document));
};
exports.detectIOS = detectIOS;
